export default (props: any) =>
<svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1" {...props} >
    <title>Edit</title>
    <g id="edit-icon" transform="matrix(1.75759,0,0,1.75759,-2069.53,-200.953)">
        <path d="M1177.48,127.372L1181.52,126.846L1178.34,123.521L1177.48,127.372ZM1191.13,118.278L1187.95,114.952L1178.72,123.177L1181.91,126.503L1191.13,118.278Z"/>
    </g>
</svg>
